import React, {Component} from 'react';
import logo from '../../images/logo_dashbo_purple.svg';
import {LocalStorage} from "../../utils/LocalStorage";
import {Navigate} from "react-router-dom";
import {FaIcon} from "../FaIcon";


export class SubscriptionNotActivePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedOut: false,
        };

        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {
        document.title = 'Dashbo - Tu cuenta está desactivada';
    }

    handleLogout() {
        LocalStorage.removeUserData();
        this.setState({loggedOut: true});
    }

    renderRedirectToLogin() {
        if (this.state.loggedOut) {
            return <Navigate to={this._loginPath()}/>
        }
    }

    _loginPath() {
        return {pathname: '/login'};
    }

    _renderContent() {
        return null;
    }

    render() {
        return [
            <nav key="nav" className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container text-center d-flex justify-content-center">
                    <a className="navbar-brand" href="#">
                        <img src={logo} className="app-logo" alt="logo" height="70"/>
                    </a>
                </div>
            </nav>,
            // `col-7` sin corte dejaba el texto en 219 px a 390 (QA-VIS-vencida-01): en el celular, ancho entero.
            <div key="content" className="container mt-3 col-12 col-md-7">
                {this._renderContent()}
                <div className="row justify-content-center mb-4">
                    <div className="col-md-8 text-center">
                        <div className="">
                            <button onClick={this.handleLogout}><FaIcon iconName="power-off"/>&nbsp;&nbsp;{this.props.t('subscription_not_active.logout')}
                            </button>

                            {this.renderRedirectToLogin()}
                        </div>
                    </div>
                </div>
            </div>
        ]
    }
}
